
import { createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers/index';
import { ACCESSIBILITY, STATE_DEFAULT } from './constants/state';
import { fromJS } from 'immutable';


const getPreloadedState = () => {
    let preloadedState 

    if(window.pmkinoFrontVars) {
        preloadedState = window.pmkinoFrontVars
    } else {
        preloadedState = STATE_DEFAULT
    }

    return fromJS(preloadedState)
}


export const store = createStore(
    rootReducer,
    getPreloadedState(),
    composeWithDevTools()
);